function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.72 4.566L17.167 19.33a1.715 1.715 0 01-1.705 1.536H6.539a1.716 1.716 0 01-1.706-1.536L3.279 4.566m-2.144 0h19.73m-13.725 0V1.993c0-.474.384-.858.858-.858h6.004c.474 0 .858.384.858.858v2.573M11 8.426v9.008m3.86-9.008l-.429 9.008M7.14 8.426l.429 9.008",
  stroke: "#FFF",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgDeleteWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22
  }, props), _ref);
}

export default SvgDeleteWhite;